// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yQXfK","buttons":"styles_buttons__1Q7DB"};